import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=e6d8c2b6&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=e6d8c2b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d8c2b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6d8c2b6')) {
      api.createRecord('e6d8c2b6', component.options)
    } else {
      api.reload('e6d8c2b6', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=e6d8c2b6&scoped=true&", function () {
      api.rerender('e6d8c2b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29hq2vqokVewN/JS/comp/PopupBox.vue"
export default component.exports